var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownLossMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36603 8.5C5.98112 9.16667 5.01887 9.16667 4.63397 8.5L0.73686 1.75C0.35196 1.08333 0.833086 0.25 1.60289 0.25L9.39712 0.250001C10.1669 0.250001 10.648 1.08333 10.2631 1.75L6.36603 8.5Z",
    fill: "#FF5858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLossMeter);
export default __webpack_public_path__ + "static/media/downLossMeter.15ec2d2d9775e004e8b6a68a85bbc1fe.svg";
export { ForwardRef as ReactComponent };